import React, { useEffect, useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import axios from '../helpers/axiosConfig';
import { useNavigate } from 'react-router-dom';
//import { AuthContext } from '../helpers/AuthContext';

function CreatCompagnie() {
  const [listeBataillon, setListeBataillon] = useState([]);
  const navigate = useNavigate();
  const initialValues = {
    name: '',
    libelle: '',
    reference: '',
  };

  useEffect(() => {
    if (!localStorage.getItem('accessToken')) {
      navigate('/login');
    }
    axios.get('/bataillon').then((res) => {
      setListeBataillon(res.data);
    });
  }, []);
  const enregistrer = (data) => {
    axios
      .post('/compagnie', data, {
        headers: { accessToken: localStorage.getItem('accessToken') },
      })
      .then((res) => console.log(res.data))
      .then((res) => console.log(res))
      .catch((error) => console.log(error));
    navigate('/compagnie');
  };

  const validation = Yup.object().shape({
    name: Yup.string().required('Veuillez remplir le name'),
    libelle: Yup.string().required('Veuillez remplir le libelle'),
    reference: Yup.string(),
  });

  return (
    <React.Fragment>
      <div className="container pt-5 mt-4">
        <div>Brigade</div>
        <Formik enctype="multipart/form-data" initialValues={initialValues} onSubmit={enregistrer} validationSchema={validation}>
          <Form>
            <div className="row">
              <div className="col">
                <label htmlFor="name">Compagnie : </label>
                <ErrorMessage className="text-danger" name="name" component="span" />
                <Field autocomplete="off" id="name" name="name" className="form-control" />
              </div>
              <div className="col">
                <label htmlFor="libelle">Libellé :</label>
                <ErrorMessage className="text-danger" name="libelle" component="span" />
                <Field autocomplete="off" id="libelle" name="libelle" className="form-control" />
              </div>
            </div>
            <div className="row">
              <div className="col">
                <label htmlFor="reference">Référence :</label>
                <ErrorMessage className="text-danger" name="reference" component="span" />
                <Field autocomplete="off" id="reference" name="reference" className="form-control" />
              </div>
            </div>
            <div className="col-md-4">
              <label htmlFor="bataillon">Bataillon : </label>
              <ErrorMessage className="text-danger" name="bataillon" component="span" />
              <Field as="select" id="bataillon" name="bataillon" className="form-control">
                <option value=""></option>
                {listeBataillon.map((bataillon, key) => {
                  return (
                    <option key={key} value={bataillon.id}>
                      {bataillon.name}
                    </option>
                  );
                })}
              </Field>
            </div>
            <div className="row">
              <div className="col">
                <button type="submit" className="btn btn-success mt-4">
                  Enregistrer
                </button>
              </div>
            </div>
          </Form>
        </Formik>
      </div>
    </React.Fragment>
  );
}

export default CreatCompagnie;
